export default __webpack_public_path__ + "static/images/flash-7cd63e010436b5d64705a78a526538e6.png";